import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function Button({ themeButton, buttonText, buttonLink }) {
  return (
    <div>
      <Link to={`${buttonLink}`} className={`${themeButton}`}>
        {buttonText}{" "}
        <span>
          <FontAwesomeIcon icon={faChevronRight} />
        </span>
      </Link>
    </div>
  );
}
